import * as React from "react";
import cx from "classnames";

import styles from "../InteractiveSearch.css";

import { InteractiveSearchRequestParams} from "../Definitions";
import { ChevronLeftItem, ChevronRightItem} from "./index";

type PaginatorProps = {
    currentPage: number;
    numberOfPages: number;
    onChange: (update: Partial<InteractiveSearchRequestParams>) => void;
};

export const Paging = (props: PaginatorProps): JSX.Element => {
    const pagesToRender = Array.from(new Set([
        1,
        props.currentPage - 1,
        props.currentPage,
        props.currentPage + 1,
        props.numberOfPages
    ]))
        .filter(page => page >= 1 &&  page <= props.numberOfPages)
        .sort((a, b) => a - b);

    return (
        <div className={styles.interactiveSearchNavigation}>
            <div
                onClick={() => {
                    if (props.currentPage - 1 >= 1) {
                        props.onChange({page: props.currentPage - 1});
                    }
                }}
                className={styles.prev}
            >
                <PaginatorItem
                    key="PREV"
                    label={<ChevronLeftItem isDisabled={props.currentPage - 1 < 1} />}
                    isDisabled={props.currentPage - 1 < 1}
                />
                <span className={cx(
                    styles.disableMobile,
                    styles.marginLeft,
                    props.currentPage - 1 < 1 ? styles.inactiveNavText : styles.activeNavText
                )}>
					ZURÜCK
				</span>
            </div>
            <PaginatorItem
                label={props.currentPage}
                isActive={true}
                className={styles.showMobile}
            />
            <div className={styles.navItems}>
                {
                    pagesToRender.map((page: number, index: number, list: number[]) => (
                        <React.Fragment key={page}>
                            {
                                index > 0 && list[index - 1] + 1 < page
                                    ? <div>...</div>
                                    : null
                            }
                            <PaginatorItem
                                label={page}
                                onClick={() => props.onChange({page})}
                                isActive={page === props.currentPage}
                            />
                        </React.Fragment>
                    ))
                }
            </div>
            <div
                onClick={() => {
                    if (props.currentPage + 1 <= props.numberOfPages) {
                        props.onChange({page: props.currentPage + 1});
                    }
                }}
                className={styles.next}
            >
				<span className={cx(
                    styles.disableMobile,
                    styles.marginRight,
                    props.currentPage + 1 > props.numberOfPages ? styles.inactiveNavText : styles.activeNavText
                )}>
					WEITER
				</span>
                <PaginatorItem
                    key="NEXT"
                    label={<ChevronRightItem isDisabled={props.currentPage + 1 > props.numberOfPages} />}
                    isDisabled={props.currentPage + 1 > props.numberOfPages}
                />
            </div>
        </div>
    )
};

type PaginatorItemProps = {
    label: React.ReactNode;
    onClick?: () => void;
    isActive?: boolean;
    isDisabled?: boolean;
    className?: string;
}
const PaginatorItem = (props: PaginatorItemProps): JSX.Element => (
    <div
        className={cx(
            styles.navItem,
            props.className,
            props.isDisabled
                ? "disabled"
                : props.isActive
                    ? styles.active
                    : styles.inActive
        )}
        onClick={props.isDisabled ? undefined : props.onClick}
    >
        {props.label}
    </div>
);
